import { CommonModule, NgIf } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { RepLicense } from '../../../../models/repEditorModels'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-license',
    templateUrl: './rep-editor-license.component.html',
    styleUrls: ['./rep-editor-license.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        DropDownListComponent,
        FormsModule,
        ReactiveFormsModule,
        CommandColumnComponent,
        CellTemplateDirective,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        AdminOnlyDirective
    ]
})
export class RepEditorLicenseComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  repLicenses: RepLicense[]
  licenseList: any[]
  activeLicenseList = this.repState.getActiveLicenseList()
  @Input() override repId: number = 0
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repLicenses) {
      this.initGrid()
    }

    if (!this.repState.licenseList) {
      this.typesService.getLicenseList().subscribe((response) => {
        this.repState.licenseList = response
      })
    }
  }

  initGrid() {
    this.clientService
      .getRepLicenseForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repLicenses = response
      })
  }

  public addHandler({ sender }) {
    const newRepLicense = new RepLicense(null)
    newRepLicense.repID = this.repId
    newRepLicense.active = true
    this.addHandlerShared({ sender }, newRepLicense)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const repLicense = new RepLicense(formGroup.value)
    this.clientService.submitRepLicenseUpdate(repLicense).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new RepLicense(dataItem)
    itemToRemove.active = false
    this.clientService.submitRepLicenseUpdate(itemToRemove).subscribe(() => {
      this.initGrid()
    })
  }

  public createFormGroup(repLicense: RepLicense): UntypedFormGroup {
    return this.formBuilder.group({
      active: repLicense.active,
      licenseID: [repLicense.licenseID, Validators.required],
      licenseType: repLicense.licenseType,
      repID: repLicense.repID,
      repLicenseID: repLicense.repLicenseID,
    })
  }
}
